import React, { useEffect, useState } from "react";
import { Helmet } from "react-helmet-async";
import EventWithUs from "./EventWithUs";
import Divider from "../common/Divider";
import axios from "axios";
import { initializeTagManager } from "../../TagManager";
import { useLocation } from "react-router-dom";
import Degree45 from "../../gallery/icons/grey45degree.png";
import GeoAlt from "../../gallery/icons/geoalt.svg";
import InfoCircle from "../../gallery/icons/info-circle.png";
import DefaultBL from "../../gallery/default/defaultBusinessLogo.png";
import Calendar from "../../gallery/icons/calender.svg";
import Alarm from "../../gallery/icons/alarm.svg";
import BuyTicket from "../../gallery/icons/buy-ticket.svg";
import EventSimilar from "./EventSimilar";
import { useDispatch, useSelector } from "react-redux";
import { updateEvent, resetEvent } from "../../app/features/event/eventSlice";
import { BeatLoader } from "react-spinners";
import { setActiveLink } from "../../app/features/nav/navSlice";
import LeftCarouselArrow from "../../gallery/icons/leftCarouselArrow.png";
import RightCarouselArrow from "../../gallery/icons/rightCarouselArrow.png";
import ArrowLeft from "../../gallery/icons/arrowLeft.png";
import ArrowRight from "../../gallery/icons/arrowRight.png";
import { resetTimer } from "../../app/features/timer/timerSlice";
import EventTicketsModal from "./EventTicketsModal";
import { resetAskSignup, resetGuest, setAskTicket, unSetHomeModal } from "../../app/features/user/userSlice";
import LogoMark from "../../gallery/default/logomark.png";
import { Link } from "react-router-dom";
import { Modal } from "bootstrap";
import { useHistory } from "react-router-dom";
import {
  canShowTicketCta,
  hasInternalTickets,
  isComingSoon,
  isExternalEvent,
  openExternalTicketing,
  shouldRenderTicketModal,
} from "../../utils/eventTicketing";

function EventDetail(props) {
  const location = useLocation();
  const history = useHistory();

  const queryParams = new URLSearchParams(location.search);

  const promo_code = queryParams.get("promo_code") || null;

  const substrings = location.pathname.split("/");
  const type = substrings["1"];
  const slug = substrings["2"];

  const dispatch = useDispatch();
  const currentEvent = useSelector((state) => state.event.currentEvent);

  const items = useSelector((state) => state.event.items);
  const ticketsSold = useSelector((state) => state.event.ticketsSold);

  const [data, setData] = useState();
  const [error, setError] = useState(null);

  useEffect(() => {
    dispatch(setActiveLink("event"));
    dispatch(resetEvent());
    dispatch(resetTimer());
    initializeTagManager();
    setError(null); // Reset error state on route change
    fetchData();

    // const backdrops = document.querySelectorAll(".modal-backdrop");
    // backdrops.forEach((el) => el.remove());
    // document.body.classList.remove("modal-open");
    // document.body.style.removeProperty("overflow");
    // document.body.style.removeProperty("padding-right");
  }, [type, slug]);

  useEffect(() => {
    if (history.action === "POP" && data && hasInternalTickets(data) && new Date(data.end_date).getTime() >= new Date().getTime()) {
      const timer = setTimeout(() => {
        const modalEl = document.getElementById("appModal");
        if (modalEl) {
          const modal = new Modal(modalEl);
          modal.show();
        }
        goToTickets();
      }, 100);

      return () => clearTimeout(timer);
    }
  }, [promo_code, data, currentEvent && currentEvent.tickets, history.action]);

  const goToTickets = () => {
    if (isExternalEvent(data)) {
      openExternalTicketing(data);
      return;
    }
    // Reset modal state and show ticket selection
    dispatch(unSetHomeModal());
    dispatch(setAskTicket());
    dispatch(resetAskSignup());
    dispatch(resetGuest());
    dispatch(resetTimer());

    // var myModal = new Modal(document.getElementById("appModal"));
    // myModal.show();
  };

  const externalEvent = isExternalEvent(data);
  const canBuyInternalTickets = data && hasInternalTickets(data) && canShowTicketCta(data);
  const canGetExternalTickets = data && externalEvent && canShowTicketCta(data);
  const showDetailTicketCta = canBuyInternalTickets || canGetExternalTickets;
  const detailTicketDisabled = Object.keys(items).length > 0 && ticketsSold.length > 0;

  const handleDetailTicketClick = () => {
    if (externalEvent) {
      openExternalTicketing(data);
      return;
    }
    goToTickets();
  };
  async function fetchData() {
    let Url = `${process.env.REACT_APP_BASE_URL}/api/${type}/${slug}`;
    if (promo_code) {
      Url = `${process.env.REACT_APP_BASE_URL}/api/${type}/${slug}${location.search}`;
    }

    await axios
      .request({
        method: "GET",
        url: Url,
        headers: {
          Authorization: process.env.REACT_APP_API_KEY,
        },
      })
      .then(function (response) {
        setData(response.data.data);
        setError(null); // Clear any previous errors
        dispatch(updateEvent(response.data.data));
      })
      .catch(function (error) {
        console.error("Event fetch error:", error);
        setError("Event not found or unavailable. Please check the URL and try again.");
        setData(null); // Clear data on error
      });
  }
  const handleCopy = (event) => {
    event.preventDefault();
    const currentUrl = window.location.href;
    if (navigator.clipboard) {
      navigator.clipboard
        .writeText(currentUrl)
        .then(() => {
          console.log("URL copied to clipboard!");
        })
        .catch((error) => {
          console.error("Failed to copy URL: ", error);
        });
    } else {
      fallbackCopyURL(currentUrl);
    }
    var myButton = document.getElementById("copylinkbtn");
    myButton.className = "btn-copy-grey";
    myButton.innerHTML = `<img src=${Degree45}  alt=""/> Copied to clipboard`;
    myButton.setAttribute("disabled", true);

    setTimeout(function () {
      myButton.className = "btn-copy-grey";
      myButton.innerHTML = `<img src=${Degree45}  alt=""/> Copy link`;
      myButton.removeAttribute("disabled");
    }, 5000);
  };
  const fallbackCopyURL = (url) => {
    const textArea = document.createElement("textarea");
    textArea.value = url;
    textArea.style.position = "fixed"; // Make it invisible
    document.body.appendChild(textArea);
    textArea.focus();
    textArea.select();
    try {
      document.execCommand("copy");
      console.log("URL copied to clipboard!");
    } catch (error) {
      console.error("Failed to copy URL: ", error);
    }
    document.body.removeChild(textArea);
  };
  const dateFormat = (d, type = 0) => {
    let date = new Date(d);

    const dayOfWeek = date.toLocaleString("en-UK", { weekday: "short" });
    var month = date.toLocaleString("en-UK", { month: "short" });
    const year = date.getFullYear();
    var monthCmp = date.toLocaleString("en-UK", { month: "long" });
    const day = date.getDate();

    let hours = date.getHours();
    const minutes = date.getMinutes();
    const ampm = hours >= 12 ? "PM" : "AM";

    hours = hours % 12;
    hours = hours ? hours : 12;
    let formattedDate = "";
    if (type === 1) {
      formattedDate = `${dayOfWeek}, ${day} ${month} ${year}, ${hours}:${minutes < 10 ? "0" + minutes : minutes} ${ampm}`;
    } else if (type === 2) {
      formattedDate = `${hours}:${minutes < 10 ? "0" + minutes : minutes}${ampm}`;
    } else if (type === 3) {
      formattedDate = `${day} ${month}`;
    } else if (type === 4) {
      formattedDate = `${day} ${monthCmp} ${date.getFullYear()}`;
    } else {
      formattedDate = `${dayOfWeek}, ${day} ${month}, ${hours}:${minutes < 10 ? "0" + minutes : minutes}${ampm}`;
    }

    return formattedDate;
  };

  return (
    <>
      <Helmet>
        {data && <title>{`Sahi Search - ${data.name}`}</title>}

        <meta name="description" content="" />
      </Helmet>

      {/* <button
        id="ncx-show-checkout"
        title="Checkout"
        style={{ display: "none" }}
      ></button>

      {nochexData && <NochexPayment nochexData={nochexData} />} */}
      {!data && !error && (
        <div className="loader-in-component-body">
          <BeatLoader color="#C6153B" />
        </div>
      )}
      {error && (
        <div className="container mt-5">
          <div className="row justify-content-center align-items-center">
            <div className="col-md-6 col-sm-12">
              <div className="text-center">
                <div className="mb-4">
                  <img src={LogoMark} alt="Error" className="img-fluid" style={{ maxWidth: "200px" }} />
                </div>
                <h2 className="text-danger mb-3">Event Not Found</h2>
                <p className="text-muted mb-4">{error}</p>
                <Link to="/" className="btn btn-primary">
                  Go Back
                </Link>
              </div>
            </div>
          </div>
        </div>
      )}
      {data && !error && (
        <>
          {!externalEvent && data && data.ticket_start_at && isComingSoon(data) && (
            <div className="alert alert-warning d-flex justify-content-center" role="alert">
              <div style={{ fontWeight: "600", fontSize: "22px" }}>
                This is an upcoming event. Tickets will be <strong>available from {dateFormat(data.ticket_start_at, 4)}.</strong> Follow us on{" "}
                <a href="https://www.facebook.com/sahisearch" target="_blank" rel="noopener noreferrer" className="text-decoration-underline text-black-50">
                  Facebook
                </a>{" "}
                or{" "}
                <a href="https://www.instagram.com/sahisearch" target="_blank" rel="noopener noreferrer" className="text-decoration-underline text-black-50">
                  Instagram
                </a>{" "}
                for updates.
              </div>
            </div>
          )}
          <div>
            {data && data.gallery.length > 0 && (
              <div id="carouselExampleInterval" className="carousel slide" data-bs-ride={data.gallery.length > 1 ? "carousel" : ""} data-bs-interval="4000">
                {/* Show indicators only if more than one image */}
                {data.gallery.length > 1 && (
                  <div className="carousel-indicators">
                    {data.gallery.map((_, index) => (
                      <button key={`indicator_${index}`} type="button" data-bs-target="#carouselExampleInterval" data-bs-slide-to={index} className={index === 0 ? "active" : ""} aria-current={index === 0 ? "true" : "false"} aria-label={`Slide ${index + 1}`}></button>
                    ))}
                  </div>
                )}

                <div className="carousel-inner carousel-inner-height align-content-center">
                  {data.gallery.map((element, index) => {
                    const customActive = index === 0 ? "active" : "";
                    return (
                      <div
                        key={`carousel_${index}`}
                        className={`carousel-item ${customActive}`}
                        style={{
                          position: "relative",
                          width: "100%",
                          height: "100%",
                          zIndex: "1",
                          textAlign: "center",
                          overflow: "hidden",
                        }}
                      >
                        <div
                          style={{
                            position: "absolute",
                            top: 0,
                            left: 0,
                            width: "100%",
                            height: "100%",
                            backgroundImage: `url(${element.image_path}/${element.image_name})`,
                            backgroundSize: "cover",
                            backgroundRepeat: "no-repeat",
                            filter: "blur(50px)",
                            zIndex: "-1",
                          }}
                        />
                        <img className="d-block carousel-img-height img-fluid" alt="..." src={`${element.image_path}/${element.image_name}`} />
                      </div>
                    );
                  })}
                </div>

                {/* Show navigation buttons only if more than one image */}
                {data.gallery.length > 1 && (
                  <>
                    <div className="carousel-nav hidden-xs">
                      <button className="carousel-control-prev" type="button" data-bs-target="#carouselExampleInterval" data-bs-slide="prev">
                        <span aria-hidden="true">
                          <img src={LeftCarouselArrow} alt="" />
                        </span>
                        <span className="visually-hidden">Previous</span>
                      </button>
                      <button className="carousel-control-next" type="button" data-bs-target="#carouselExampleInterval" data-bs-slide="next">
                        <span aria-hidden="true">
                          <img src={RightCarouselArrow} alt="" />
                        </span>
                        <span className="visually-hidden">Next</span>
                      </button>
                    </div>

                    <div className="carousel-nav hidden-md">
                      <button className="carousel-control-prev" type="button" data-bs-target="#carouselExampleInterval" data-bs-slide="prev">
                        <span aria-hidden="true">
                          <img src={ArrowLeft} alt="" />
                        </span>
                        <span className="visually-hidden">Previous</span>
                      </button>
                      <button className="carousel-control-next" type="button" data-bs-target="#carouselExampleInterval" data-bs-slide="next">
                        <span aria-hidden="true">
                          <img src={ArrowRight} alt="" />
                        </span>
                        <span className="visually-hidden">Next</span>
                      </button>
                    </div>
                  </>
                )}
              </div>
            )}

            {data && data.gallery.length === 0 && data.image_name && (
              <div id="carouselExampleCaptions" className="carousel slide">
                <div className="carousel-inner carousel-inner-height align-content-center">
                  <div
                    className={`carousel-item active`}
                    style={{
                      position: "relative",
                      width: "100%",
                      height: "100%",
                      zIndex: "1",
                      textAlign: "center",
                      overflow: "hidden",
                    }}
                  >
                    <div
                      style={{
                        position: "absolute",
                        top: 0,
                        left: 0,
                        width: "100%",
                        height: "100%",
                        backgroundImage: `url(${data.image_name ? data.image_path : DefaultBL})`,
                        backgroundSize: "cover",
                        backgroundRepeat: "no-repeat",
                        filter: "blur(50px)",
                        zIndex: "-1",
                      }}
                    />
                    <img className="d-block carousel-img-height img-fluid" alt="..." src={data.image_name ? data.image_path : DefaultBL} />
                  </div>
                </div>
              </div>
            )}
          </div>
          <div className="container">
            <div className="inner-content">
              <div className="row">
                <div className="col-lg-12 col-md-8 col-sm-12">
                  <div className="event-detail-ticket-wrap">
                    {showDetailTicketCta && (
                      <button
                        type="button"
                        className={`btn btn-event-modal mt-4 d-none d-md-block ${detailTicketDisabled ? "btn-disabled" : ""}`}
                        data-bs-toggle={externalEvent ? undefined : "modal"}
                        data-bs-target={externalEvent ? undefined : "#appModal"}
                        onClick={handleDetailTicketClick}
                      >
                        <img src={BuyTicket} alt="" className="me-3" />
                        Buy tickets
                      </button>
                    )}
                    {/* Modal */}
                    {data && shouldRenderTicketModal(data) && !externalEvent && <EventTicketsModal id={"appModal"} closeId={"appModalClose"} />}
                  </div>

                  <h3 className="detail-event-title">{data ? (data.name ? data.name : "") : ""}</h3>
                  <p>
                    <button id="copylinkbtn" className="btn-copy-grey" onClick={handleCopy}>
                      <img src={Degree45} alt="" />
                      &nbsp;Copy link
                    </button>
                  </p>
                  <p className="location-on-detail paragraph-margin-sm">
                    <img src={GeoAlt} alt="" />
                    &nbsp;
                    {data.address1 ? `${data.address1}, ` : ""}
                    {data ? (data.location ? data.location : "") : ""} {data ? (data.postal_code ? ` - ${data.postal_code}` : "") : ""}
                  </p>
                  <p className="location-on-detail paragraph-margin-sm">
                    <img src={InfoCircle} alt="" />
                    &nbsp; Organised by {data.user_slug ? <Link to={`/events/${data.user_slug}`}>{data.user_name}</Link> : data.user_name}
                  </p>
                  {parseInt(data.show_start_date) === parseInt(1) && (
                    <p className="location-on-detail me-1">
                      <img src={Calendar} alt="" />
                      &nbsp;{dateFormat(data.start_date, 1)}
                    </p>
                  )}
                  {data.last_entry_time && parseInt(data.show_start_date) === parseInt(1) && (
                    <p className="location-on-detail me-1">
                      <img src={Alarm} alt="" />
                      &nbsp; Doors close at {dateFormat(data.last_entry_time, 1)}
                    </p>
                  )}
                  <p className="paragraph-margin-sm">
                    <span className="badge rounded-pill card-business">{data ? data.category : ""}</span>
                    {data && data.adult_event && <span className="badge rounded-pill for-adults">18+ only</span>}
                    {!externalEvent && data.ticket_start_at && isComingSoon(data) && <span className="badge rounded-pill for-adults">Coming soon</span>}
                    {externalEvent && <span className="badge rounded-pill for-adults">External tickets</span>}
                    {new Date(data.end_date).getTime() <= new Date().getTime() && <span className="badge rounded-pill for-adults">Expired</span>}
                  </p>
                  <hr className="detail-custom-border" />

                  <div className="">
                    <h6 className="detail-heading">Event details</h6>
                    <p
                      className="detail-desc"
                      dangerouslySetInnerHTML={{
                        __html: data ? (data.detail ? data.detail.replace(/\n/g, "<br />") : "") : "",
                      }}
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
          <EventSimilar item={data.id} page={data.page} category={data.category_id} location={data.location_id} />
          <Divider />
          <EventWithUs />
          {showDetailTicketCta && (
            <div className="sticky-footer">
              <button
                type="button"
                className={`btn btn-buy-tickets d-block d-md-none ${detailTicketDisabled ? "btn-disabled" : ""}`}
                data-bs-toggle={externalEvent ? undefined : "modal"}
                data-bs-target={externalEvent ? undefined : "#appModal"}
                onClick={handleDetailTicketClick}
              >
                <img src={BuyTicket} alt="" className="me-3" />
                Buy Tickets
              </button>
            </div>
          )}
        </>
      )}
    </>
  );
}

export default EventDetail;
